import NProgress from "nprogress";
NProgress.configure({
  minimum: 0.15,
  showSpinner: false,
  trickleRate: 0.1,
  trickleSpeed: 800
});
export default NProgress;